import { render, staticRenderFns } from "./RubricSalOutBillModal.vue?vue&type=template&id=38b0f741&scoped=true&"
import script from "./RubricSalOutBillModal.vue?vue&type=script&lang=js&"
export * from "./RubricSalOutBillModal.vue?vue&type=script&lang=js&"
import style0 from "./RubricSalOutBillModal.vue?vue&type=style&index=0&id=38b0f741&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b0f741",
  null
  
)

export default component.exports